<script>
	import { Confetti } from 'svelte-confetti';

	export let winner = '';
	export let show = false;
	let confettiFired = false;

	// Configuration for confetti
	const confettiOptions = {
		x: [-5, 5],
		y: [0, 0.1],
		duration: 3000,
		amount: 100,
		fallDistance: '100vh'
	};

	function close() {
		show = false; // Reset for next time
		confettiFired = false;
	}

	function handleKeydown(event) {
		// Close on Escape key press
		if (event.key === 'Escape') {
			close();
		}
	}

	// Use this method to ensure confetti fires every time the popup shows
	$: if (show) {
		// Small timeout ensures this runs after the component is fully visible
		setTimeout(() => {
			confettiFired = true;
		}, 10);
	}
</script>

{#if show}
	<div class="popup-overlay" role="presentation" on:click|self={close} on:keydown={handleKeydown}>
		<div
			class="popup-content"
			role="dialog"
			aria-modal="true"
			aria-labelledby="winner-title"
			on:click|stopPropagation
		>
			{#if confettiFired}
				<Confetti
					x={confettiOptions.x}
					y={confettiOptions.y}
					duration={confettiOptions.duration}
					amount={confettiOptions.amount}
					fallDistance={confettiOptions.fallDistance}
				/>
			{/if}
			<button class="close-button" on:click={close} aria-label="Close">×</button>
			<h2 id="winner-title">Winner!</h2>
			<div class="winner-name">{winner}</div>
			<button class="ok-button" on:click={close}>OK</button>
		</div>
	</div>
{/if}

<style>
	.popup-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.6);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		animation: fadeIn 0.3s ease;
	}

	.popup-content {
		background-color: white;
		border-radius: 10px;
		padding: 30px;
		text-align: center;
		max-width: 90%;
		width: 350px;
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
		position: relative;
		animation: scaleIn 0.3s ease;
	}

	h2 {
		color: #3498db;
		margin-top: 10px;
		margin-bottom: 20px;
		font-size: 28px;
	}

	.winner-name {
		font-size: 30px;
		font-weight: bold;
		color: #2c3e50;
		margin: 20px 0;
		padding: 10px;
		background-color: #f8f9fa;
		border-radius: 5px;
		word-break: break-word;
	}

	.close-button {
		position: absolute;
		top: 10px;
		right: 10px;
		font-size: 24px;
		background: none;
		border: none;
		cursor: pointer;
		color: #95a5a6;
	}

	.close-button:hover {
		color: #3498db;
	}

	.ok-button {
		padding: 10px 30px;
		font-size: 16px;
		background-color: #4caf50;
		color: white;
		border: none;
		border-radius: 5px;
		cursor: pointer;
		margin-top: 10px;
		transition: background-color 0.3s;
	}

	.ok-button:hover {
		background-color: #45a049;
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	@keyframes scaleIn {
		from {
			transform: scale(0.9);
			opacity: 0;
		}
		to {
			transform: scale(1);
			opacity: 1;
		}
	}

	/* Mobile specific styles */
	@media (max-width: 480px) {
		.popup-content {
			padding: 20px 15px;
			width: 85%;
			max-width: 300px;
		}

		h2 {
			font-size: 22px;
			margin-top: 5px;
			margin-bottom: 15px;
		}

		.winner-name {
			font-size: 24px;
			margin: 15px 0;
			padding: 8px;
		}

		.ok-button {
			padding: 8px 20px;
			font-size: 14px;
		}
	}
</style>
